import styled from "styled-components";
import { themeOptions } from "styles";


export const StyledBasicAutosizeInput = styled.div`
  width: 100%;
  
  .basic-input {
    padding: 9px 12px;
    border: 0px solid #dadada;
    border-radius: 6px;
    outline: none;
    
    &:focus {
      border-color: ${themeOptions.palette.green.main};
      box-shadow: 0 0 0 3px var(--color-off-white);
    }
  }
`;
